import cn from 'classnames';
import React from 'react';
import type { ContentContainer as Props } from './content-container.types';
import { themes } from './content-container.types';

const ContentContainer: React.FC<React.PropsWithChildren<Props>> & {
  themes: typeof themes;
} = ({ children, className, id, raw, theme }) => (
  <div
    className={cn(
      'content-container',
      {
        'content-container--raw': raw,
        [`content-container--${theme}`]: theme,
      },
      className
    )}
    id={id}
  >
    {children}
  </div>
);

ContentContainer.themes = themes;

export default ContentContainer;
